<template>
  <article
    class="m-card-element m-card-element-design-2 m-card-primary m-card-transition"
    tag="article"
    @click.prevent="goToProject()"
  >
    <div class="m-card-element-info-data">
      <img
        v-if="element.imagen"
        key="realImg"
        :alt="element.titulo"
        :src="element.imagen"
      >
      <img
        v-else
        key="defaultImg"
        :alt="element.titulo"
        src="@/assets/img/ds2.png"
      >
      <h2 class="m-card-element-design-2-name">
        {{ element.titulo }}
      </h2>
    </div>

    <div class="m-card-element-info-state">
      <div class="a-radialprogress">
        <div>
          <div
            v-if="element.activa"
            :class="overallPercentage < 50
              ? `progress-circle p${overallPercentage} under50`
              : `progress-circle p${overallPercentage} over50`"
          >
            <div :class="['left-half-clipper', overallPercentage < 50 ? 'left-half-clipper-under50' : 'left-half-clipper-over50']">
              <div class="first50-bar"></div>
              <div class="value-bar"></div>
            </div>
          </div>
          <span v-if="overallPercentage === 100">
            <i class="fas fa-check ckeck-icon"></i>
          </span>
        </div>

        <span
          v-if="element.activa"
          class="progress-label"
        >
          {{ overallPercentage === 100 ? 'Completado' : `${overallPercentage} % Visto` }}
        </span>
      </div>

      <div
        v-if="canAccess"
        key="allowed"
        class="m-card-element-info-state-of-price"
      >
        {{ $t('mFeedSectionContentCardDesing2.accessGranted') }}
      </div>
      <div
        v-else
        key="notAllowed"
        class="m-card-element-info-access-denied"
      >
        {{ $t('mFeedSectionContentCardDesing2.accessDenied') }}
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'MoleculeFeedSectionContentCardDesign2',

  props: {
    element: Object,
    elementCategorias: Array
  },

  computed: {
    canAccess () {
      return this.element.activa && !this.element.eliminada
    },

    overallPercentage () {
      if (this.element.cant_nodos === 0) {
        return 0
      } else {
        return parseInt(((this.element.nodos_vistos * 100) / this.element.cant_nodos).toFixed(0))
      }
    }
  },

  methods: {
    goToProject () {
      if (this.canAccess && this.element.tipo === 0) {
        this.$store.commit('setSelectedProyect', this.element)
        this.$router.push(`/${this.$t('rPaths.asset')}/${this.element.id_proyecto}/${this.$t('mEditionMenu.asset.content.subject')}`)
      } else if (this.canAccess && this.element.tipo === 1) {
        this.$store.commit('setSelectedMap', this.element)
        this.$router.push(`/${this.$t('rPaths.map')}/${this.element.id_proyecto}/${this.$t('mEditionMenu.asset.content.subject')}`)
      } else {
        this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.myShopping.subject')}/${this.element.venta}/${this.$t('mEditionMenu.billing.myShopping.children.record.subedition')}`)
      }
    }
  }
}
</script>
